import AdyenCreditCardAuthActionModal from '../AdyenCreditCardAuthActionModal/AdyenCreditCardAuthActionModal';
import BancontactMobileAuthActionModal from '../BancontactMobileAuthActionModal/BancontactMobileAuthActionModal';

const RetryPaymentOverlays: React.FC = () => {
  return (
    <>
      <BancontactMobileAuthActionModal />
      <AdyenCreditCardAuthActionModal />
    </>
  );
};

export default RetryPaymentOverlays;
